module.exports = __webpack_public_path__ + "static/scroll-mobile-b0d0cac99a6aed32ae830b8fa827dc3d.png";